<!-- DONE: 添加一个弹框，弹出图片。 -->
<template>
  <div v-if="is_mp">
    <van-dialog style="min-height:300px" v-model="showDialog" title="活动" :show-cancel-button="false">
      <van-image :src="require('@/assets/bought-dialog.jpeg')" />
    </van-dialog>
  </div>
</template>

<script>
import browserTypeAdapter from "@/utils/browserTypeAdapter";
import { Dialog } from 'vant';
export default {
  name: 'BoughtDialog', components: {
    [Dialog.Component.name]: Dialog.Component,
  }, data() {
    return {
      showDialog: true,
      browserTypeStr: null,
    }
  },
  watch: {},
  computed: {
    is_mp() {
      return this.browserTypeStr === "miniprogram"
    }
  },
  created() {
    this.browserTypeStr = localStorage.getItem("browserTypeAdapter") || browserTypeAdapter();
  }, mounted() { }, methods: {}

}
</script>
  
<style lang='' scoped>
  
</style>
